module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gameBox"
  }, [_c('div', {
    staticClass: "gameHeader"
  }, [_c('a', {
    staticClass: "iphone",
    on: {
      "click": _vm.jumpIphone
    }
  }, [_vm._v("Xem chi tiết chương trình >>")]), _vm._v(" "), _c('a', {
    staticClass: "winner",
    on: {
      "click": _vm.jumpWinner
    }
  }, [_vm._v("Kết quả quay số trúng thưởng >>")])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gameFooter"
  }, [_c('p', [_vm._v("THỜI HẠN CHƯƠNG TRÌNH: 05/11/2018 – 30/06/2019")]), _vm._v(" "), _c('button', [_c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.xb.topnews"
    }
  }, [_vm._v("Tải ngay")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42c61eca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameRule.vue
// module id = 922
// module chunks = 1